import Generic from "../pages/globals/generics/GenericForm/Generic";
import GenericsPage from "../pages/globals/generics/GenericsPage";
import LegalEntity from "../pages/registers/legalEntity/LegalEntityForm/LegalEntity";
import LegalEntityPage from "../pages/registers/legalEntity/LegalEntityPage";

import { DomainProvider } from "@4uhub/lib4uhub";
import { Outlet, RouteObject } from "react-router-dom";
import AditionalSettingsPage from "../pages/admSystem/aditionalSettings/AditionalSettingsPage";
import CompaniesPage from "../pages/admSystem/companies/CompaniesPage";
import Company from "../pages/admSystem/companies/CompanyForm/Company";
import CompanyGroup from "../pages/admSystem/companyGroups/CompanyGroupForm/CompanyGroup";
import CompanyGroupsPage from "../pages/admSystem/companyGroups/CompanyGroupsPage";
import Establishment from "../pages/admSystem/establishments/EstablishmentForm/EstablishmentForm";
import EstablishmentsPage from "../pages/admSystem/establishments/EstablishmentsPage";
import Roles from "../pages/admSystem/roles/RolesForm/Roles";
import RolesPage from "../pages/admSystem/roles/RolesPage";
import User from "../pages/admSystem/users/UserForm/UserForm";
import UsersPage from "../pages/admSystem/users/UsersPage";
import Register from "../pages/applications/Register/RegisterForm/Register";
import RegisterPage from "../pages/applications/Register/RegisterPage";
import EvaluationLogs from "../pages/Evaluations/EvaluationLogs/EvaluationLogs";
import EvaluationLogsTicket from "../pages/Evaluations/EvaluationLogsTicket/EvaluationLogsTicket";
import Form from "../pages/Evaluations/Forms/FormsForm.tsx/Form";
import FormsPage from "../pages/Evaluations/Forms/FormsPage";
import Question from "../pages/Evaluations/Questions/QuestionForm/Question";
import QuestionsPage from "../pages/Evaluations/Questions/QuestionsPage";
import ExtensionSettings from "../pages/extensionsStore/ExtensionSettings/ExtensionSettings";
import ExtensionSetting from "../pages/extensionsStore/ExtensionSettings/ExtensionSettingsForm/ExtensionSetting";
import ExtensionsStorePage from "../pages/extensionsStore/ExtensionsStorePage";
import Bank from "../pages/globals/banks/BankForm/Bank";
import BanksPage from "../pages/globals/banks/BanksPage";
import CitiesPage from "../pages/globals/cities/CitiesPage";
import City from "../pages/globals/cities/CityForm/City";
import CountriesPage from "../pages/globals/countries/CountriesPage";
import Country from "../pages/globals/countries/CountryForm/Country";
import DefaultSettingsForm from "../pages/globals/extensions/DefaultSettings/DefaultSettingsForm/DefaultSettingsForm";
import DefaultSettingsPage from "../pages/globals/extensions/DefaultSettings/DefaultSettingsPage";
import Extension from "../pages/globals/extensions/ExtensionForm/Extension";
import ExtensionsPage from "../pages/globals/extensions/ExtensionsPage";
import PriceRulesForm from "../pages/globals/extensions/PriceRules/PriceRulesForm/PriceRulesForm";
import PriceRulesPage from "../pages/globals/extensions/PriceRules/PriceRulesPage";
import JobsPage from "../pages/globals/jobs/JobsPage";
import Languages from "../pages/globals/languages/LanguagesForm/Languages";
import LanguagesPage from "../pages/globals/languages/LanguagesPage";
import Neighborhood from "../pages/globals/neighborhoods/NeighborhoodForm/Neighborhood";
import NeighborhoodsPage from "../pages/globals/neighborhoods/NeighborhoodsPage";
import Province from "../pages/globals/provinces/ProvinceForm/ProvinceForm";
import ProvincesPage from "../pages/globals/provinces/ProvincesPage";
import HealthChecksLogsPage from "../pages/Logs/HealthChecksLogsPage";
import LogRegisterErrors from "../pages/Logs/LogRegisterErrors";
import LogsPage from "../pages/logsPage/logsPage";
import Import from "../pages/registers/individuals/ImportsPeople/ImportForm/Import";
import ImportList from "../pages/registers/individuals/ImportsPeople/ImportList";
import ImportsPeoplePage from "../pages/registers/individuals/ImportsPeople/ImportsPeoplePage";
import Individual from "../pages/registers/individuals/IndividualForm/Individual";
import IndividualsPage from "../pages/registers/individuals/IndividualsPages";
import IndividualValidation from "../pages/registers/individualValidations/IndividualValidation/IndividualValidation";
import IndividualValidationsPage from "../pages/registers/individualValidations/individualValidationsPage";
import Config from "../pages/settings/Settings/Settings4uBus/Configs/ConfigsForm/Config";
import ConfigsPage from "../pages/settings/Settings/Settings4uBus/Configs/ConfigsPage";
import Rule from "../pages/settings/Settings/Settings4uBus/ExternalExamPrescription/Rules/RuleForm/Rule";
import RulesPage from "../pages/settings/Settings/Settings4uBus/ExternalExamPrescription/Rules/RulesPage";
import IpmGeneralSetting from "../pages/settings/Settings/Settings4uBus/Ipm/IpmGeneralSettings/IpmGeneralSettingForm/IpmGeneralSetting";
import IpmGeneralSettingsPage from "../pages/settings/Settings/Settings4uBus/Ipm/IpmGeneralSettings/IpmGeneralSettingsPage";
import SyncPage from "../pages/settings/Settings/Settings4uBus/Sync/SyncPage";
import Event from "../pages/settings/Settings/SettingsCrm/Events/EventForm/Event";
import EventsPage from "../pages/settings/Settings/SettingsCrm/Events/EventsPage";
import ExternalProcessType from "../pages/settings/Settings/SettingsCrm/ExternalProcessType/ExternalProcessTypeForm/ExternalProcessType";
import ExternalProcessTypePage from "../pages/settings/Settings/SettingsCrm/ExternalProcessType/ExternalProcessTypePage";
import ProtocolGenerate from "../pages/settings/Settings/SettingsCrm/ProtocolGenerate/ProtocolGenerateForm/ProtocolGenerate";
import ProtocolGeneratePage from "../pages/settings/Settings/SettingsCrm/ProtocolGenerate/ProtocolGeneratePage";
import ProtocolDefault from "../pages/settings/Settings/SettingsCrm/ProtocolsDefault/ProtocolDefaultForm/ProtocolDefault";
import ProtocolsDefaultPage from "../pages/settings/Settings/SettingsCrm/ProtocolsDefault/ProtocolsDefaultPage";
import TicketDefaultDocCategory from "../pages/settings/Settings/SettingsCrm/TicketDefaultDocCategories/TicketDefaultDocCategoryForm/TicketDefaultDocCategory";
import TicketDefaultDocCategoriesPage from "../pages/settings/Settings/SettingsCrm/TicketDefaultDocCategories/TicketDefaultDocCategoriesPage";
import TicketAutoFinishRule from "../pages/settings/Settings/SettingsCrm/TicketAutoFinishRule/TicketAutoFinishRuleForm/TicketAutoFinishRule";
import TicketAutoFinishRulesPage from "../pages/settings/Settings/SettingsCrm/TicketAutoFinishRule/TicketAutoFinishRulesPage";
import TicketService from "../pages/settings/Settings/SettingsCrm/ticketService/TicketServiceForm/TicketService";
import TicketServicePage from "../pages/settings/Settings/SettingsCrm/ticketService/TicketServicePage";
import TicketServiceTypeBot from "../pages/settings/Settings/SettingsCrm/ticketService/TicketServiceTypeBotForm/TicketServiceTypeBot";
import TicketServiceWhats from "../pages/settings/Settings/SettingsCrm/ticketService/TicketServiceWhatsForm/TicketServiceWhats";
import EstablishmentParam from "../pages/settings/Settings/SettingsGeneral/establishmentParams/EstablishmentParamsForm/EstablishmentParam";
import EstablishmentParamsPage from "../pages/settings/Settings/SettingsGeneral/establishmentParams/EstablishmentParamsPage";
import HealthCheck from "../pages/settings/Settings/SettingsGeneral/healthChecks/HealthCheckForm/HealthCheck";
import HealthChecksPage from "../pages/settings/Settings/SettingsGeneral/healthChecks/HealthChecksPage";
import Holiday from "../pages/settings/Settings/SettingsGeneral/holidays/HolidayForm/Holiday";
import HolidaysPage from "../pages/settings/Settings/SettingsGeneral/holidays/HolidaysPage";
import HealthProgramType from "../pages/settings/Settings/SettingsPreventMedicine/HealthProgramTypes/HealthProgramTypeForm/HealthProgramType";
import HealthProgramTypesPage from "../pages/settings/Settings/SettingsPreventMedicine/HealthProgramTypes/HealthProgramTypesPage";
import WorkGroupType from "../pages/settings/Settings/SettingsPreventMedicine/WorkGroupTypes/WorkGroupTypeForm/WorkGroupType";
import WorkGroupTypesPage from "../pages/settings/Settings/SettingsPreventMedicine/WorkGroupTypes/WorkGroupTypesPage";
import ScheduleCheckIn from "../pages/settings/Settings/SettingsSchedule/TasySchedule/ScheduleCheckIn/ScheduleCheckInForm/ScheduleCheckIn";
import ScheduleCheckInPage from "../pages/settings/Settings/SettingsSchedule/TasySchedule/ScheduleCheckIn/ScheduleCheckInPage";
import ScheduleConfirmation from "../pages/settings/Settings/SettingsSchedule/TasySchedule/ScheduleConfirmation/ScheduleConfirmationForm/ScheduleConfirmation";
import ScheduleConfirmationPage from "../pages/settings/Settings/SettingsSchedule/TasySchedule/ScheduleConfirmation/ScheduleConfirmationPage";
import CardsTemplatesPage from "../pages/settings/Settings/SettingsSiteApp/CardsTemplates/CardsTemplatesPage";
import CardTemplate from "../pages/settings/Settings/SettingsSiteApp/CardsTemplates/CardTemplateForm/CardTemplate";
import SiteAppCheckIn from "../pages/settings/Settings/SettingsSiteApp/SiteAppCheckln/SiteAppCheckInForm/SiteAppCheckIn";
import SiteAppCheckInPage from "../pages/settings/Settings/SettingsSiteApp/SiteAppCheckln/SiteAppChecklnPage";
import ParamDefaultEstablishment from "../pages/settings/Settings/SettingsSystem/paramDefaultEstabishment/ParamDefaultEstablishmentForm/ParamDefaultEstablishment";
import ParamDefaultEstablishmentPage from "../pages/settings/Settings/SettingsSystem/paramDefaultEstabishment/ParamDefaultEstablishmentPage";
import SettingsCache from "../pages/settings/Settings/SettingsSystem/SettingsCache/SettingsCache";
import SettingsCentralBank from "../pages/settings/Settings/SettingsSystem/SettingsCentralBank/SettingsCentralBank";
import SettingsCertillion from "../pages/settings/Settings/SettingsSystem/SettingsCertillion/SettingsCertillion";
import SettingsCorreios from "../pages/settings/Settings/SettingsSystem/SettingsCorreios/SettingsCorreios";
import SettingsExecuteSql from "../pages/settings/Settings/SettingsSystem/SettingsExecuteSql/SettingsExecuteSql";
import SettingsGeolocalization from "../pages/settings/Settings/SettingsSystem/SettingsGeolocalization/SettingsGeolocalization";
import SettingsPage from "../pages/settings/SettingsPage";
import PreferencesPage from "../pages/preferences/PreferencesPage";
import WelcomePage from "../pages/welcomePage";
import QuickAnswerPage from "../pages/settings/Settings/SettingsCrm/QuickAnswer/QuickAnswerPage";
import QuickAnswer from "../pages/settings/Settings/SettingsCrm/QuickAnswer/QuickAnswerForm/QuickAnswer";
import TicketAutoTransferRulesPage from "../pages/settings/Settings/SettingsCrm/TicketAutoTransferRule/TicketAutoTransferRulesPage";
import TicketAutoTransferRule from "../pages/settings/Settings/SettingsCrm/TicketAutoTransferRule/TicketAutoTransferRuleForm/TicketAutoTransferRule";
import SendLimitMonthsPage from "../pages/settings/Settings/SettingsCrm/SendLimitMonths/SendLimitMonthsPage";
import SendLimitDiariesPage from "../pages/settings/Settings/SettingsCrm/SendLimitDiaries/SendLimitDiariesPage";
import SendLimitMonths from "../pages/settings/Settings/SettingsCrm/SendLimitMonths/SendLimitMonthsForm/SendLimitMonths";
import SendLimitDiaries from "../pages/settings/Settings/SettingsCrm/SendLimitDiaries/SendLimitDiariesForm/SendLimitDiaries";
import ActiveServiceSearchSurveyLogs from "../pages/Evaluations/ActiveServiceSearchSurveyLogs/ActiveServiceSearchSurveyLogs";
import TicketAutoInactiveRulesPage from "../pages/settings/Settings/SettingsCrm/TicketAutoInactiveRule/TicketAutoInactiveRulePage";
import TicketAutoInactiveRule from "../pages/settings/Settings/SettingsCrm/TicketAutoInactiveRule/TicketAutoInactiveRuleForm/TicketAutoInactiveRule";
import ScheduleFilterUserPage from "../pages/settings/Settings/SettingsSchedule/TasySchedule/ScheduleFilterUser/ScheduleFilterUserPage";
import ScheduleFilterUser from "../pages/settings/Settings/SettingsSchedule/TasySchedule/ScheduleFilterUser/ScheduleFilterUserForm/ScheduleFilterUser";
import TasySchedMenu from "../pages/settings/Settings/SettingsSchedule/TasySchedMenu/TasySchedMenuForm/TasySchedMenu";
import TasySchedMenuPage from "../pages/settings/Settings/SettingsSchedule/TasySchedMenu/TasySchedMenuPage";
import DigitalCertificatesPage from "../pages/admSystem/digitalCertificates/DigitalCertificatesPage";
import DigitalCertificate from "../pages/admSystem/digitalCertificates/DigitalCertificateForm/DigitalCertificate";

const dashboardRoutes: RouteObject[] = [
  {
    index: true,
    element: <WelcomePage />,
  },
  {
    path: "globals",
    element: <Outlet />,
    children: [
      {
        path: "generics",
        element: (
          <DomainProvider value={{ domainName: "generic" }}>
            <GenericsPage />
          </DomainProvider>
        ),
      },
      {
        path: "generics/new",
        element: (
          <DomainProvider
            value={{ domainName: "generic" }}
            actions={["Create"]}
          >
            <Generic />
          </DomainProvider>
        ),
      },
      {
        path: "generics/:id/edit",
        element: (
          <DomainProvider value={{ domainName: "generic" }} actions={["Read"]}>
            <Generic />
          </DomainProvider>
        ),
      },
      {
        path: "extensions",
        element: (
          <DomainProvider value={{ domainName: "extension" }}>
            <ExtensionsPage />
          </DomainProvider>
        ),
      },
      {
        path: "extensions/:id/edit",
        element: (
          <DomainProvider
            value={{ domainName: "extension" }}
            actions={["Create"]}
          >
            <Extension />
          </DomainProvider>
        ),
      },
      {
        path: "extensions/:extId/default-settings",
        element: (
          <DomainProvider
            value={{ domainName: "extension" }}
            actions={["Read"]}
          >
            <DefaultSettingsPage />
          </DomainProvider>
        ),
      },
      {
        path: "extensions/:extId/default-settings/new",
        element: (
          <DomainProvider
            value={{ domainName: "extension" }}
            actions={["Read"]}
          >
            <DefaultSettingsForm />
          </DomainProvider>
        ),
      },
      {
        path: "extensions/:extId/default-settings/:id/edit",
        element: (
          <DomainProvider
            value={{ domainName: "extension" }}
            actions={["Read"]}
          >
            <DefaultSettingsForm />
          </DomainProvider>
        ),
      },
      {
        path: "extensions/:extId/price-rules",
        element: (
          <DomainProvider
            value={{ domainName: "extension" }}
            actions={["Read"]}
          >
            <PriceRulesPage />
          </DomainProvider>
        ),
      },
      {
        path: "extensions/:extId/price-rules/new",
        element: (
          <DomainProvider
            value={{ domainName: "extension" }}
            actions={["Read"]}
          >
            <PriceRulesForm />
          </DomainProvider>
        ),
      },
      {
        path: "extensions/:extId/price-rules/:id/edit",
        element: (
          <DomainProvider
            value={{ domainName: "extension" }}
            actions={["Read"]}
          >
            <PriceRulesForm />
          </DomainProvider>
        ),
      },

      {
        path: "languages",
        element: (
          <DomainProvider value={{ domainName: "language" }}>
            <LanguagesPage />
          </DomainProvider>
        ),
      },
      {
        path: "languages/new",
        element: (
          <DomainProvider
            value={{ domainName: "language" }}
            actions={["Create"]}
          >
            <Languages />
          </DomainProvider>
        ),
      },
      {
        path: "languages/:id/edit",
        element: (
          <DomainProvider value={{ domainName: "language" }} actions={["Read"]}>
            <Languages />
          </DomainProvider>
        ),
      },
      {
        path: "countries",
        element: (
          <DomainProvider value={{ domainName: "country" }}>
            <CountriesPage />
          </DomainProvider>
        ),
      },
      {
        path: "countries/new",
        element: (
          <DomainProvider
            value={{ domainName: "country" }}
            actions={["Create"]}
          >
            <Country />
          </DomainProvider>
        ),
      },
      {
        path: "countries/:id/edit",
        element: (
          <DomainProvider value={{ domainName: "country" }} actions={["Read"]}>
            <Country />
          </DomainProvider>
        ),
      },
      {
        path: "provinces",
        element: (
          <DomainProvider value={{ domainName: "provinces" }}>
            <ProvincesPage />
          </DomainProvider>
        ),
      },
      {
        path: "provinces/new",
        element: (
          <DomainProvider
            value={{ domainName: "provinces" }}
            actions={["Create"]}
          >
            <Province />
          </DomainProvider>
        ),
      },
      {
        path: "provinces/:id/edit",
        element: (
          <DomainProvider
            value={{ domainName: "provinces" }}
            actions={["Read"]}
          >
            <Province />
          </DomainProvider>
        ),
      },
      {
        path: "cities",
        element: (
          <DomainProvider value={{ domainName: "cities" }}>
            <CitiesPage />
          </DomainProvider>
        ),
      },
      {
        path: "cities/new",
        element: (
          <DomainProvider value={{ domainName: "cities" }} actions={["Create"]}>
            <City />
          </DomainProvider>
        ),
      },
      {
        path: "cities/:id/edit",
        element: (
          <DomainProvider value={{ domainName: "cities" }} actions={["Read"]}>
            <City />
          </DomainProvider>
        ),
      },
      {
        path: "neighborhoods",
        element: (
          <DomainProvider value={{ domainName: "neighborhoods" }}>
            <NeighborhoodsPage />
          </DomainProvider>
        ),
      },
      {
        path: "neighborhoods/new",
        element: (
          <DomainProvider
            value={{ domainName: "neighborhoods" }}
            actions={["Create"]}
          >
            <Neighborhood />
          </DomainProvider>
        ),
      },
      {
        path: "neighborhoods/:id/edit",
        element: (
          <DomainProvider
            value={{ domainName: "neighborhoods" }}
            actions={["Read"]}
          >
            <Neighborhood />
          </DomainProvider>
        ),
      },
      {
        path: "banks",
        element: (
          <DomainProvider value={{ domainName: "banks" }}>
            <BanksPage />
          </DomainProvider>
        ),
      },
      {
        path: "banks/new",
        element: (
          <DomainProvider value={{ domainName: "banks" }} actions={["Create"]}>
            <Bank />
          </DomainProvider>
        ),
      },
      {
        path: "banks/:id/edit",
        element: (
          <DomainProvider value={{ domainName: "banks" }} actions={["Read"]}>
            <Bank />
          </DomainProvider>
        ),
      },
      {
        path: "jobs",
        element: (
          <DomainProvider value={{ domainName: "jobs" }}>
            <JobsPage />
          </DomainProvider>
        ),
      },
    ],
  },

  {
    path: "people",
    element: <Outlet />,
    children: [
      {
        path: "legalEntities",
        element: (
          <DomainProvider value={{ domainName: "legalentity" }}>
            <LegalEntityPage />
          </DomainProvider>
        ),
        id: "Legal Entity Page",
      },
      {
        path: "legalEntities/new",
        element: (
          <DomainProvider
            value={{ domainName: "legalentity" }}
            actions={["Create"]}
          >
            <LegalEntity />
          </DomainProvider>
        ),
      },
      {
        path: "legalEntities/:id/edit",
        element: (
          <DomainProvider
            value={{ domainName: "legalentity" }}
            actions={["Read"]}
          >
            <LegalEntity />
          </DomainProvider>
        ),
      },
      {
        path: "logs",
        element: <LogsPage />,
      },
      {
        path: "individuals",
        element: (
          <DomainProvider value={{ domainName: "individual" }}>
            <IndividualsPage />
          </DomainProvider>
        ),
      },
      {
        path: "individuals/new",
        element: (
          <DomainProvider
            value={{ domainName: "individual" }}
            actions={["Create"]}
          >
            <Individual />
          </DomainProvider>
        ),
      },
      {
        path: "individuals/:id/edit",
        element: (
          <DomainProvider
            value={{ domainName: "individual" }}
            actions={["Read"]}
          >
            <Individual />
          </DomainProvider>
        ),
      },
      {
        path: "individuals/imports",
        element: (
          <DomainProvider value={{ domainName: "individual" }}>
            <ImportsPeoplePage />
          </DomainProvider>
        ),
      },
      {
        path: "individuals/imports/new",
        element: (
          <DomainProvider value={{ domainName: "individual" }}>
            <Import />
          </DomainProvider>
        ),
      },
      {
        path: "individuals/imports/:id",
        element: (
          <DomainProvider value={{ domainName: "individual" }}>
            <ImportList />
          </DomainProvider>
        ),
      },
      {
        path: "individualValidations",
        element: (
          <DomainProvider value={{ domainName: "individualvalidation" }}>
            <IndividualValidationsPage />
          </DomainProvider>
        ),
      },
      {
        path: "individualValidations/validate",
        element: (
          <DomainProvider value={{ domainName: "individualvalidation" }}>
            <IndividualValidation />
          </DomainProvider>
        ),
      },
      {
        path: "individualValidations/validate/:id",
        element: (
          <DomainProvider value={{ domainName: "individualvalidation" }}>
            <IndividualValidation />
          </DomainProvider>
        ),
      },
    ],
  },
  {
    path: "admSystem",
    element: <Outlet />,
    children: [
      {
        path: "roles",
        element: (
          <DomainProvider value={{ domainName: "role" }}>
            <RolesPage />
          </DomainProvider>
        ),
      },
      {
        path: "roles/new",
        element: (
          <DomainProvider value={{ domainName: "role" }} actions={["Create"]}>
            <Roles />
          </DomainProvider>
        ),
      },
      {
        path: "roles/:id/edit",
        element: (
          <DomainProvider value={{ domainName: "role" }} actions={["Read"]}>
            <Roles />
          </DomainProvider>
        ),
      },
      {
        path: "establishmentParams",
        element: (
          <DomainProvider value={{ domainName: "establishmentparams" }}>
            <EstablishmentParamsPage />
          </DomainProvider>
        ),
      },
      {
        path: "establishmentParams/new",
        element: (
          <DomainProvider
            value={{ domainName: "establishmentparams" }}
            actions={["Create"]}
          >
            <EstablishmentParam />
          </DomainProvider>
        ),
      },
      {
        path: "establishmentParams/:id/edit",
        element: (
          <DomainProvider
            value={{ domainName: "establishmentparams" }}
            actions={["Read"]}
          >
            <EstablishmentParam />
          </DomainProvider>
        ),
      },
      {
        path: "users",
        element: (
          <DomainProvider
            value={{
              domainName: "users",
            }}
          >
            <UsersPage />
          </DomainProvider>
        ),
      },
      {
        path: "users/new",
        element: (
          <DomainProvider value={{ domainName: "users" }} actions={["Create"]}>
            <User />
          </DomainProvider>
        ),
      },
      {
        path: "users/:id/edit",
        element: (
          <DomainProvider value={{ domainName: "users" }} actions={["Read"]}>
            <User />
          </DomainProvider>
        ),
      },
      {
        path: "establishments",
        element: (
          <DomainProvider
            value={{
              domainName: "establishment",
            }}
          >
            <EstablishmentsPage />
          </DomainProvider>
        ),
      },
      {
        path: "establishments/new",
        element: (
          <DomainProvider
            value={{ domainName: "establishment" }}
            actions={["Create"]}
          >
            <Establishment />
          </DomainProvider>
        ),
      },
      {
        path: "establishments/:id/edit",
        element: (
          <DomainProvider
            value={{ domainName: "establishment" }}
            actions={["Read"]}
          >
            <Establishment />
          </DomainProvider>
        ),
      },
      {
        path: "aditionalSettings",
        element: <AditionalSettingsPage />,
      },
      {
        path: "aditionalSettings/cardsTemplates",
        element: (
          <DomainProvider
            value={{ domainName: "establishmentparammodelcards" }}
          >
            <CardsTemplatesPage />
          </DomainProvider>
        ),
      },
      {
        path: "aditionalSettings/cardsTemplates/new",
        element: (
          <DomainProvider
            value={{ domainName: "establishmentparammodelcards" }}
            actions={["Create"]}
          >
            <CardTemplate />
          </DomainProvider>
        ),
      },
      {
        path: "aditionalSettings/cardsTemplates/:id/edit",
        element: (
          <DomainProvider
            value={{ domainName: "establishmentparammodelcards" }}
            actions={["Read"]}
          >
            <CardTemplate />
          </DomainProvider>
        ),
      },
      {
        path: "companygroups",
        element: (
          <DomainProvider value={{ domainName: "companygroups" }}>
            <CompanyGroupsPage />
          </DomainProvider>
        ),
      },
      {
        path: "companygroups/new",
        element: (
          <DomainProvider value={{ domainName: "companygroups" }}>
            <CompanyGroup />
          </DomainProvider>
        ),
      },
      {
        path: "companygroups/:id/edit",
        element: (
          <DomainProvider value={{ domainName: "companygroups" }}>
            <CompanyGroup />
          </DomainProvider>
        ),
      },
      {
        path: "companies",
        element: (
          <DomainProvider value={{ domainName: "companies" }}>
            <CompaniesPage />
          </DomainProvider>
        ),
      },
      {
        path: "companies/new",
        element: (
          <DomainProvider
            value={{ domainName: "companies" }}
            actions={["Create"]}
          >
            <Company />
          </DomainProvider>
        ),
      },
      {
        path: "companies/:id/edit",
        element: (
          <DomainProvider
            value={{ domainName: "companies" }}
            actions={["Read"]}
          >
            <Company />
          </DomainProvider>
        ),
      },
      {
        path: "companyDigitalCertificates",
        element: (
          <DomainProvider value={{ domainName: "companydigitalcertificate" }}>
            <DigitalCertificatesPage />
          </DomainProvider>
        ),
      },
      {
        path: "companyDigitalCertificates/new",
        element: (
          <DomainProvider
            value={{ domainName: "companydigitalcertificate" }}
            actions={["Create"]}
          >
            <DigitalCertificate />
          </DomainProvider>
        ),
      },
      {
        path: "companyDigitalCertificates/:id/edit",
        element: (
          <DomainProvider
            value={{ domainName: "companydigitalcertificate" }}
            actions={["Read"]}
          >
            <DigitalCertificate />
          </DomainProvider>
        ),
      },
    ],
  },
  {
    path: "applications/register",
    element: (
      <DomainProvider value={{ domainName: "siteapp" }} actions={["Read"]}>
        <RegisterPage />
      </DomainProvider>
    ),
  },
  {
    path: "applications/register/new",
    element: (
      <DomainProvider value={{ domainName: "siteapp" }} actions={["Create"]}>
        <Register />
      </DomainProvider>
    ),
  },
  {
    path: "applications/register/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "siteapp" }} actions={["Read"]}>
        <Register />
      </DomainProvider>
    ),
  },
  {
    path: "extensions-store",
    element: (
      <DomainProvider value={{ domainName: "siteappextension" }}>
        <ExtensionsStorePage />
      </DomainProvider>
    ),
  },
  {
    path: "extension-settings/:siteAppId/:extensionId",
    element: (
      <DomainProvider value={{ domainName: "extensionconfig" }}>
        <ExtensionSettings />
      </DomainProvider>
    ),
  },
  {
    path: "extension-settings/:siteAppId/:extensionId/new",
    element: (
      <DomainProvider
        value={{ domainName: "extensionconfig" }}
        actions={["Create"]}
      >
        <ExtensionSetting />
      </DomainProvider>
    ),
  },
  {
    path: "extension-settings/:siteAppId/:extensionId/:id/edit",
    element: (
      <DomainProvider
        value={{ domainName: "extensionconfig" }}
        actions={["Read"]}
      >
        <ExtensionSetting />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4uSiteApp/digitalTriage",
    element: (
      <DomainProvider value={{ domainName: "tasytriagecheckinule" }}>
        <SiteAppCheckInPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4uSiteApp/digitalTriage/new",
    element: (
      <DomainProvider value={{ domainName: "tasytriagecheckinule" }}>
        <SiteAppCheckIn />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4uSiteApp/digitalTriage/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "tasytriagecheckinule" }}>
        <SiteAppCheckIn />
      </DomainProvider>
    ),
  },

  {
    path: "preferences",
    element: <PreferencesPage />,
  },
  {
    path: "settings",
    element: (
      <DomainProvider value={{ domainName: "settings" }}>
        <SettingsPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/system/cache",
    element: (
      <DomainProvider
        value={{ domainName: "generalsettings" }}
        actions={["Read"]}
      >
        <SettingsCache />
      </DomainProvider>
    ),
  },
  {
    path: "settings/system/paramsDefaultEstablishment",
    element: (
      <DomainProvider value={{ domainName: "paramdefaultestablishment" }}>
        <ParamDefaultEstablishmentPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/system/paramsDefaultEstablishment/new",
    element: (
      <DomainProvider value={{ domainName: "paramdefaultestablishment" }}>
        <ParamDefaultEstablishment />
      </DomainProvider>
    ),
  },
  {
    path: "settings/system/paramsDefaultEstablishment/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "paramdefaultestablishment" }}>
        <ParamDefaultEstablishment />
      </DomainProvider>
    ),
  },
  {
    path: "settings/generalSettings/holidays",
    element: (
      <DomainProvider value={{ domainName: "holidays" }}>
        <HolidaysPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/generalSettings/holidays/new",
    element: (
      <DomainProvider value={{ domainName: "holidays" }} actions={["Create"]}>
        <Holiday />
      </DomainProvider>
    ),
  },
  {
    path: "settings/generalSettings/holidays/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "holidays" }} actions={["Read"]}>
        <Holiday />
      </DomainProvider>
    ),
  },
  {
    path: "settings/generalSettings/establishmentParams",
    element: (
      <DomainProvider value={{ domainName: "establishmentparams" }}>
        <EstablishmentParamsPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/generalSettings/establishmentParams/new",
    element: (
      <DomainProvider
        value={{ domainName: "establishmentparams" }}
        actions={["Create"]}
      >
        <EstablishmentParam />
      </DomainProvider>
    ),
  },
  {
    path: "settings/generalSettings/establishmentParams/:id/edit",
    element: (
      <DomainProvider
        value={{ domainName: "establishmentparams" }}
        actions={["Read"]}
      >
        <EstablishmentParam />
      </DomainProvider>
    ),
  },
  {
    path: "settings/generalSettings/healthChecks",
    element: (
      <DomainProvider value={{ domainName: "healthcheck" }}>
        <HealthChecksPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/generalSettings/healthChecks/new",
    element: (
      <DomainProvider
        value={{ domainName: "healthcheck" }}
        actions={["Create"]}
      >
        <HealthCheck />
      </DomainProvider>
    ),
  },
  {
    path: "settings/generalSettings/healthChecks/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "healthcheck" }} actions={["Read"]}>
        <HealthCheck />
      </DomainProvider>
    ),
  },
  {
    path: "settings/generalSettings/cardsTemplates",
    element: (
      <DomainProvider value={{ domainName: "establishmentparammodelcards" }}>
        <CardsTemplatesPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/generalSettings/cardsTemplates/new",
    element: (
      <DomainProvider
        value={{ domainName: "establishmentparammodelcards" }}
        actions={["Create"]}
      >
        <CardTemplate />
      </DomainProvider>
    ),
  },
  {
    path: "settings/generalSettings/cardsTemplates/:id/edit",
    element: (
      <DomainProvider
        value={{ domainName: "establishmentparammodelcards" }}
        actions={["Read"]}
      >
        <CardTemplate />
      </DomainProvider>
    ),
  },
  {
    path: "settings/system/generalSettings/correios",
    element: (
      <DomainProvider
        value={{ domainName: "generalsettings" }}
        actions={["Update"]}
      >
        <SettingsCorreios />
      </DomainProvider>
    ),
  },
  {
    path: "settings/system/generalSettings/certillion",
    element: (
      <DomainProvider
        value={{ domainName: "esigncertillionconfig" }}
        actions={["Update"]}
      >
        <SettingsCertillion />
      </DomainProvider>
    ),
  },
  {
    path: "settings/system/generalSettings/centralBank",
    element: (
      <DomainProvider
        value={{ domainName: "generalsettings" }}
        actions={["Update"]}
      >
        <SettingsCentralBank />
      </DomainProvider>
    ),
  },
  {
    path: "settings/system/generalSettings/geolocalization",
    element: (
      <DomainProvider
        value={{ domainName: "generalsettings" }}
        actions={["Update"]}
      >
        <SettingsGeolocalization />
      </DomainProvider>
    ),
  },
  {
    path: "settings/system/executeSql",
    element: (
      <DomainProvider value={{ domainName: "executesql" }}>
        <SettingsExecuteSql />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketProtocolRule",
    element: (
      <DomainProvider value={{ domainName: "ticketprotocolrule" }}>
        <ProtocolGeneratePage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketProtocolRule/new",
    element: (
      <DomainProvider value={{ domainName: "ticketprotocolrule" }}>
        <ProtocolGenerate />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketProtocolRule/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "ticketprotocolrule" }}>
        <ProtocolGenerate />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketService",
    element: (
      <DomainProvider value={{ domainName: "ticketservice" }}>
        <TicketServicePage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketService/new",
    element: (
      <DomainProvider
        value={{ domainName: "ticketservice" }}
        actions={["Create"]}
      >
        <TicketService />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketService/:id/edit",
    element: (
      <DomainProvider
        value={{ domainName: "ticketservice" }}
        actions={["Read"]}
      >
        <TicketService />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketService/whatsappConfig/:ticketServiceId/new",
    element: (
      <DomainProvider value={{ domainName: "ticketservice" }}>
        <TicketServiceWhats />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketService/whatsappConfig/:ticketServiceId/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "ticketservice" }}>
        <TicketServiceWhats />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketService/typeBotConfig/:ticketServiceId/new",
    element: (
      <DomainProvider value={{ domainName: "ticketservice" }}>
        <TicketServiceTypeBot />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketService/typeBotConfig/:ticketServiceId/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "ticketservice" }}>
        <TicketServiceTypeBot />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketAutoFinishRule",
    element: (
      <DomainProvider value={{ domainName: "ticketautofinishrule" }}>
        <TicketAutoFinishRulesPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketAutoFinishRule/new",
    element: (
      <DomainProvider
        value={{ domainName: "ticketautofinishrule" }}
        actions={["Create"]}
      >
        <TicketAutoFinishRule />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketAutoFinishRule/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "ticketautofinishrule" }}>
        <TicketAutoFinishRule />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketAutoTransferRule",
    element: (
      <DomainProvider value={{ domainName: "ticketautotransferrule" }}>
        <TicketAutoTransferRulesPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketAutoTransferRule/new",
    element: (
      <DomainProvider
        value={{ domainName: "ticketautotransferrule" }}
        actions={["Create"]}
      >
        <TicketAutoTransferRule />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketAutoTransferRule/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "ticketautotransferrule" }}>
        <TicketAutoTransferRule />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketDefaultDocs",
    element: (
      <DomainProvider value={{ domainName: "ticketdefaultdoc" }}>
        <ProtocolsDefaultPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketDefaultDocs/new",
    element: (
      <DomainProvider
        value={{ domainName: "ticketdefaultdoc" }}
        actions={["Create"]}
      >
        <ProtocolDefault />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketDefaultDocs/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "ticketdefaultdoc" }}>
        <ProtocolDefault />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketDefaultDocCategories",
    element: (
      <DomainProvider value={{ domainName: "ticketdefaultdocategory" }}>
        <TicketDefaultDocCategoriesPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketDefaultDocCategories/new",
    element: (
      <DomainProvider
        value={{ domainName: "ticketdefaultdocategory" }}
        actions={["Create"]}
      >
        <TicketDefaultDocCategory />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketDefaultDocCategories/:id/edit",
    element: (
      <DomainProvider
        value={{ domainName: "ticketdefaultdocategory" }}
        actions={["Update"]}
      >
        <TicketDefaultDocCategory />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/events",
    element: (
      <DomainProvider value={{ domainName: "ticketevent" }}>
        <EventsPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/events/new",
    element: (
      <DomainProvider
        value={{ domainName: "ticketevent" }}
        actions={["Create"]}
      >
        <Event />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/events/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "ticketevent" }}>
        <Event />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/externalProcessType",
    element: (
      <DomainProvider value={{ domainName: "ticketexternalprocesstype" }}>
        <ExternalProcessTypePage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/externalProcessType/new",
    element: (
      <DomainProvider
        value={{ domainName: "ticketexternalprocesstype" }}
        actions={["Create"]}
      >
        <ExternalProcessType />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/externalProcessType/:id/edit",
    element: (
      <DomainProvider
        value={{ domainName: "ticketexternalprocesstype" }}
        actions={["Update"]}
      >
        <ExternalProcessType />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/quickAnswer",
    element: (
      <DomainProvider value={{ domainName: "ticketchannelquickansweradm" }}>
        <QuickAnswerPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/quickAnswer/new",
    element: (
      <DomainProvider value={{ domainName: "ticketchannelquickansweradm" }}>
        <QuickAnswer />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/quickAnswer/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "ticketchannelquickansweradm" }}>
        <QuickAnswer />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/sendLimitMonths",
    element: (
      <DomainProvider value={{ domainName: "sendlimitmonth" }}>
        <SendLimitMonthsPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/sendLimitMonths/new",
    element: (
      <DomainProvider value={{ domainName: "sendlimitmonth" }}>
        <SendLimitMonths />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/sendLimitMonths/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "sendlimitmonth" }}>
        <SendLimitMonths />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/sendLimitDiaries",
    element: (
      <DomainProvider value={{ domainName: "sendlimitdiary" }}>
        <SendLimitDiariesPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/sendLimitDiaries/new",
    element: (
      <DomainProvider value={{ domainName: "sendlimitdiary" }}>
        <SendLimitDiaries />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/sendLimitDiaries/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "sendlimitdiary" }}>
        <SendLimitDiaries />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketAutoInactivityRule",
    element: (
      <DomainProvider value={{ domainName: "ticketautoinactiverule" }}>
        <TicketAutoInactiveRulesPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketAutoInactivityRule/new",
    element: (
      <DomainProvider value={{ domainName: "ticketautoinactiverule" }}>
        <TicketAutoInactiveRule />
      </DomainProvider>
    ),
  },
  {
    path: "settings/crm/ticketAutoInactivityRule/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "ticketautoinactiverule" }}>
        <TicketAutoInactiveRule />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4ubus/ipm/generalSettings",
    element: (
      <DomainProvider value={{ domainName: "barramentoipm" }}>
        <IpmGeneralSettingsPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4ubus/ipm/generalSettings/new",
    element: (
      <DomainProvider value={{ domainName: "barramentoipm" }}>
        <IpmGeneralSetting />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4ubus/ipm/generalSettings/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "barramentoipm" }}>
        <IpmGeneralSetting />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4ubus/globals",
    element: (
      <DomainProvider value={{ domainName: "barramento" }}>
        <ConfigsPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4ubus/globals/new",
    element: (
      <DomainProvider value={{ domainName: "barramento" }}>
        <Config />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4ubus/globals/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "barramento" }}>
        <Config />
      </DomainProvider>
    ),
  },

  {
    path: "settings/4ubus/globals/sync",
    element: (
      <DomainProvider value={{ domainName: "barramentosync" }}>
        <SyncPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4ubus/externalExamPrescription/rules",
    element: (
      <DomainProvider value={{ domainName: "forubusrulerequestextpresproc" }}>
        <RulesPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4ubus/externalExamPrescription/rules/new",
    element: (
      <DomainProvider
        value={{ domainName: "forubusrulerequestextpresproc" }}
        actions={["Create"]}
      >
        <Rule />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4ubus/externalExamPrescription/rules/:id/edit",
    element: (
      <DomainProvider
        value={{ domainName: "forubusrulerequestextpresproc" }}
        actions={["Update"]}
      >
        <Rule />
      </DomainProvider>
    ),
  },
  {
    path: "settings/hcp/workGroupTypes",
    element: (
      <DomainProvider value={{ domainName: "ticketservicemessage" }}>
        <WorkGroupTypesPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/hcp/workGroupTypes/new",
    element: (
      <DomainProvider value={{ domainName: "ticketservicemessage" }}>
        <WorkGroupType />
      </DomainProvider>
    ),
  },
  {
    path: "settings/hcp/workGroupTypes/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "ticketservicemessage" }}>
        <WorkGroupType />
      </DomainProvider>
    ),
  },
  {
    path: "settings/hcp/healthProgramTypes",
    element: (
      <DomainProvider value={{ domainName: "healthprogramtype" }}>
        <HealthProgramTypesPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/hcp/healthProgramTypes/new",
    element: (
      <DomainProvider value={{ domainName: "healthprogramtype" }}>
        <HealthProgramType />
      </DomainProvider>
    ),
  },
  {
    path: "settings/hcp/healthProgramTypes/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "healthprogramtype" }}>
        <HealthProgramType />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4uSched/tasyCalendar/checkIn",
    element: (
      <DomainProvider value={{ domainName: "tasyschedconfirmationrule" }}>
        <ScheduleCheckInPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4uSched/tasyCalendar/checkIn/new",
    element: (
      <DomainProvider value={{ domainName: "tasyschedconfirmationrule" }}>
        <ScheduleCheckIn />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4uSched/tasyCalendar/checkIn/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "tasyschedconfirmationrule" }}>
        <ScheduleCheckIn />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4uSched/tasyCalendar/confirmation",
    element: (
      <DomainProvider value={{ domainName: "tasyschedconfirmationrule" }}>
        <ScheduleConfirmationPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4uSched/tasyCalendar/confirmation/new",
    element: (
      <DomainProvider
        value={{ domainName: "tasyschedconfirmationrule" }}
        actions={["Create"]}
      >
        <ScheduleConfirmation />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4uSched/tasyCalendar/confirmation/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "tasyschedconfirmationrule" }}>
        <ScheduleConfirmation />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4uSched/tasyCalendar/scheduleFilterUser",
    element: (
      <DomainProvider value={{ domainName: "schedulefilteruser" }}>
        <ScheduleFilterUserPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4uSched/tasyCalendar/scheduleFilterUser/new",
    element: (
      <DomainProvider
        value={{ domainName: "schedulefilteruser" }}
        actions={["Create"]}
      >
        <ScheduleFilterUser />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4uSched/tasyCalendar/scheduleFilterUser/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "schedulefilteruser" }}>
        <ScheduleFilterUser />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4uSched/menuSchedulingPortalApp",
    element: (
      <DomainProvider value={{ domainName: "tasyschedmenu" }}>
        <TasySchedMenuPage />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4uSched/menuSchedulingPortalApp/new",
    element: (
      <DomainProvider
        value={{ domainName: "tasyschedmenu" }}
        actions={["Create"]}
      >
        <TasySchedMenu />
      </DomainProvider>
    ),
  },
  {
    path: "settings/4uSched/menuSchedulingPortalApp/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "tasyschedmenu" }}>
        <TasySchedMenu />
      </DomainProvider>
    ),
  },
  {
    path: "evaluation/questions",
    element: (
      <DomainProvider value={{ domainName: "question" }}>
        <QuestionsPage />
      </DomainProvider>
    ),
  },
  {
    path: "evaluation/questions/new",
    element: (
      <DomainProvider value={{ domainName: "question" }} actions={["Create"]}>
        <Question />
      </DomainProvider>
    ),
  },
  {
    path: "evaluation/questions/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "question" }}>
        <Question />
      </DomainProvider>
    ),
  },
  {
    path: "logs/healthcheck",
    element: (
      <DomainProvider value={{ domainName: "healthcheckevent" }}>
        <HealthChecksLogsPage />
      </DomainProvider>
    ),
  },
  {
    path: "logs/logRegisterError",
    element: (
      <DomainProvider value={{ domainName: "logregistererror" }}>
        <LogRegisterErrors />
      </DomainProvider>
    ),
  },

  {
    path: "evaluation/evaluationForms",
    element: (
      <DomainProvider value={{ domainName: "evaluationforms" }}>
        <FormsPage />
      </DomainProvider>
    ),
  },
  {
    path: "evaluation/evaluationForms/new",
    element: (
      <DomainProvider
        value={{ domainName: "evaluationforms" }}
        actions={["Create"]}
      >
        <Form />
      </DomainProvider>
    ),
  },
  {
    path: "evaluation/evaluationForms/:id/edit",
    element: (
      <DomainProvider value={{ domainName: "evaluationforms" }}>
        <Form />
      </DomainProvider>
    ),
  },
  {
    path: "evaluation/evaluationLogs",
    element: (
      <DomainProvider value={{ domainName: "evalMovEncSatisfactionlogs" }}>
        <EvaluationLogs />
      </DomainProvider>
    ),
  },
  {
    path: "evaluation/evaluationLogsTicket",
    element: (
      <DomainProvider value={{ domainName: "evalMovEncSatisfactionlogs" }}>
        <EvaluationLogsTicket />
      </DomainProvider>
    ),
  },
  {
    path: "evaluation/activeServiceSearchSurvey",
    element: (
      <DomainProvider value={{ domainName: "evalMovEncSatisfactionlogs" }}>
        <ActiveServiceSearchSurveyLogs />
      </DomainProvider>
    ),
  },
];

export default dashboardRoutes;
